import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { SearchBarStore } from '../search-bar.store';

const RECENT_PREVIEW = 2;
const EAGER_IMAGES = 7;
let nextId = 0;

@Component({
  selector: 'sharry-search-suggestions',
  standalone: true,
  imports: [RouterLink, I18NextModule],
  templateUrl: './search-suggestions.component.html',
  styleUrl: './search-suggestions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchSuggestionsComponent {
  readonly store = inject(SearchBarStore);
  readonly uid = `search-suggestions-${nextId++}`;
  readonly eagerImages = EAGER_IMAGES;

  readonly showAllRecent = signal(false);
  readonly canExpandRecent = computed(() => this.store.recentSearches().length > RECENT_PREVIEW);
  readonly visibleRecent = computed(() => {
    const searches = this.store.recentSearches();
    return this.showAllRecent() ? searches : searches.slice(0, RECENT_PREVIEW);
  });
}
